const files = {
  description: 'file with training',
  trainmentWeb: 'Playlist with web trainment',
  trainmentApp: 'Playlist with app trainment',
};

export default files;
